

import * as React from 'react';
import styles from '../Navbar.module.css';


const Arrow = (props) => (
<svg className={styles.sadrzajStrelica} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.3937 11.1636C20.339 10.6078 19.8729 10.172 19.2979 10.172H10.1697L14.0429 6.29883C14.4705 5.87115 14.4705 5.17323 14.0429 4.73739L13.0032 3.69771C12.5755 3.27003 11.8776 3.27003 11.4417 3.69771L3.91727 11.2222C3.70367 11.4363 3.59375 11.7171 3.59375 12.0003C3.59375 12.2811 3.70367 12.5643 3.91727 12.7779L11.4417 20.3028C11.8699 20.7305 12.5673 20.7305 13.0032 20.3028L14.0429 19.2632C14.4705 18.8355 14.4705 18.1376 14.0429 17.7017L10.1697 13.842H19.2926C19.8979 13.842 20.3913 13.35 20.3937 12.7457V11.1636Z" fill="#666666" fillOpacity="0.7"/>
</svg>
);

export default Arrow;
